"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelButton = void 0;
var react_1 = __importDefault(require("react"));
var TypescriptHelpers_1 = require("../utils/TypescriptHelpers");
var LabelHelpers_1 = require("./LabelHelpers");
var CertificationButton_1 = require("./certification/CertificationButton");
var SensitivityButton_1 = require("./sensitivity/SensitivityButton");
var WarningButton_1 = require("./warning/WarningButton");
function LabelButtonInner(props) {
    switch (props.category) {
        case 'certification':
            return react_1.default.createElement(CertificationButton_1.CertificationLabel, __assign({}, props));
        case 'warning':
            return react_1.default.createElement(WarningButton_1.WarningLabel, __assign({}, props));
        case 'sensitivity':
            return react_1.default.createElement(SensitivityButton_1.SensitivityLabel, __assign({}, props));
        default:
            (0, TypescriptHelpers_1.assertUnreachable)(props);
            return react_1.default.createElement(react_1.default.Fragment, null);
    }
}
function LabelButton(props) {
    var _a;
    return (react_1.default.createElement(LabelHelpers_1.LabelButtonContext.Provider, { value: (_a = props.controls) !== null && _a !== void 0 ? _a : LabelHelpers_1.defaultLabelRenderControls },
        react_1.default.createElement(LabelButtonInner, __assign({}, props))));
}
exports.LabelButton = LabelButton;
//# sourceMappingURL=LabelButtons.js.map